module.exports = __webpack_public_path__ + "media/images/icons/icn_009-dbf1907137fd39a352e10d9fe427991f.svg";